import { loadState, LocalStorageState, persistState } from 'common/localStorage';

const LS_KEY = 'myRunsTab';

export function loadMyRuns() {
  const state = loadState();

  return state[LS_KEY] ?? {};
}

export function persistMyRuns(state: LocalStorageState[typeof LS_KEY] = {}) {
  const currentState = loadMyRuns();
  const { experimentsOnly, sortBy, sortFieldType, sortFieldAggregationMode, sortDirection } = state;

  const newState = { ...currentState };

  if (experimentsOnly !== undefined) {
    newState.experimentsOnly = experimentsOnly;
  }

  if (sortBy !== undefined && sortFieldType !== undefined && sortDirection !== undefined) {
    newState.sortBy = sortBy;
    newState.sortFieldType = sortFieldType;
    newState.sortFieldAggregationMode = sortFieldAggregationMode;
    newState.sortDirection = sortDirection;
  }

  persistState({
    myRunsTab: newState,
  });
}
